var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldenSpotifySvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "teenyicons:spotify-solid",
    clipPath: "url(#clip0_502_5426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.199219 12C0.199219 8.8174 1.4635 5.76516 3.71394 3.51472C5.96438 1.26428 9.01662 0 12.1992 0C15.3818 0 18.4341 1.26428 20.6845 3.51472C22.9349 5.76516 24.1992 8.8174 24.1992 12C24.1992 15.1826 22.9349 18.2348 20.6845 20.4853C18.4341 22.7357 15.3818 24 12.1992 24C9.01662 24 5.96438 22.7357 3.71394 20.4853C1.4635 18.2348 0.199219 15.1826 0.199219 12ZM12.5608 8.4752C9.96722 8.264 7.32562 8.5808 5.16082 9.3456L4.62802 7.8368C7.02802 6.9888 9.89682 6.6528 12.692 6.8816C15.4808 7.1088 18.2568 7.9072 20.4408 9.3904L19.5416 10.7136C17.6456 9.4272 15.1576 8.688 12.5608 8.4752ZM5.52082 12.7872C11.0344 11.8112 14.8776 12.312 18.0632 14.5984L18.996 13.2976C15.3192 10.6576 10.9704 10.1984 5.24242 11.2128L5.52082 12.7872ZM6.05842 16.1856C7.63602 15.8016 9.57842 15.6336 11.4856 15.8208C13.3992 16.008 15.22 16.5472 16.6088 17.5248L17.5288 16.2144C15.844 15.0304 13.7288 14.4336 11.6408 14.2288C9.64495 14.0359 7.63095 14.1721 5.67922 14.632L6.05842 16.1856Z",
    fill: "#FFDCA8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_502_5426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.199219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenSpotifySvg);
export default __webpack_public_path__ + "static/media/GoldenSpotifySvg.2209560f2ed6b3a11ddfd1e11942686f.svg";
export { ForwardRef as ReactComponent };